import loginForm from './loginform';

window.addEventListener('DOMContentLoaded', function () {
    loginForm.init();
});
